export const ArchiveIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7425_5144)">
      <path
        d="M12 1.5C12 1.10218 11.842 0.720644 11.5607 0.43934C11.2794 0.158035 10.8978 0 10.5 0L1.5 0C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5L0 4.5H0.5V12H11.5V4.5H12V1.5ZM1 1.5C1 1.36739 1.05268 1.24021 1.14645 1.14645C1.24021 1.05268 1.36739 1 1.5 1H10.5C10.6326 1 10.7598 1.05268 10.8536 1.14645C10.9473 1.24021 11 1.36739 11 1.5V3.5H1V1.5ZM10.5 11H1.5V4.5H10.5V11Z"
        fill="currentColor"
      />
      <path d="M7.99975 6H3.99976V7.00001H7.99975V6Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_7425_5144">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
